// extracted by mini-css-extract-plugin
export default {"L2SubscriptionConfirmation":"styles_L2SubscriptionConfirmation__ljj6Y","fadeIn":"styles_fadeIn__qG7Rt"};